var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Dashboard.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-38007ff1\"}!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dashboard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/layouts/Dashboard.vue
// module id = 326
// module chunks = 0